module.exports = __webpack_public_path__ + "static/pp_with_linus-8a53edbdb62bcc2c0e2bdcec384f1628.jpg";